import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTIENER LISTA DE CLIENTES
export const getTipoPurchase = async () => {
    const result = await PrivateInterceptor('tipos/Purchase', 'GET')
    return result;
};
